{
  "sword": {
    "name": "sword",
    "tiles": {
      "frames": {
        "idle": [
          [224, 0, 28, 32],
          [224, 0, 28, 32],
          [224, 0, 28, 32],
          [224, 0, 28, 32],
          [224, 0, 28, 32],
          [252, 0, 28, 32],
          [252, 0, 28, 32],
          [252, 0, 28, 32],
          [252, 0, 28, 32],
          [252, 0, 28, 32]
        ],
        "attack": [
          [0, 0, 28, 32],
          [28, 0, 28, 32],
          [56, 0, 28, 32],
          [84, 0, 28, 32],
          [112, 0, 28, 32],
          [140, 0, 28, 32],
          [168, 0, 28, 32],
          [196, 0, 28, 32],
          [224, 0, 28, 32],
          [252, 0, 28, 32]
        ]
      },
      "speed": 0.3,
      "top": 10
    },
    "size": {
      "width": 28,
      "height": 32
    }
  }
}
